// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__JB0kQ","dragIcon":"Choice_dragIcon__1ERAR","left":"Choice_left__2QLDq","input":"Choice_input__2xZAm"};